// extracted by mini-css-extract-plugin
export default {"popper":"BeBJK9YDgaIK_EY6tgHH"};